import styled from 'styled-components';
import HeaderSection from '../shared/HeaderSection/HeaderSection';

export const UpgradeSuggestionHeader = styled(HeaderSection)`
  @media (max-width: 767px) {
    && .dp-new-plan-selection-back {
      display: block;
    }
  }
`;
